import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CatalogApiPort } from './ports/catalog-api.port';
import { AdessoCatalogApiAdapter } from './adapters/adesso-catalog-api.adapter';

/**
 * Provides CatalogApiPort backed by the adesso-connector-api adapter.
 */
export function provideCatalogApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: CatalogApiPort, useClass: AdessoCatalogApiAdapter }
  ]);
}
